import lunr, { Index } from 'lunr';

export function searchInIndex(search: string, index: Index): string[] {
    if (!search) {
        return [];
    }
    // We split and remove search on spaces || "+" || "#"
    const tokens = search
        .split(/[ +#-]/)
        .filter((x) => x.length >= 2)
        // This line removes accents
        .map((token) => token.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    if (tokens.length === 0) {
        return [];
    }
    return index
        .query(function (q): void {
            tokens.forEach((token) => {
                // If the token is containg numbers only, we are looking for a
                // perfect match and give it a boost of 1000
                // eslint-disable-next-line sonarjs/concise-regex -- explicit pattern improves readability for non-trivial number detection
                if (/^[0-9]+/.exec(token)) {
                    q.term(token, { boost: 1000 });
                } else {
                    // Exact token match with a boost of 100
                    q.term(token, { boost: 100 });
                    // Toke* match with a boost of 10
                    q.term(token, {
                        usePipeline: false,
                        wildcard: lunr.Query.wildcard.TRAILING,
                        boost: 10,
                    });
                    // Fuzzy search => Token match with a distance of 1
                    // e.g. Tken || Tokne || Tokem || Tokeen
                    q.term(token, {
                        usePipeline: false,
                        editDistance: 1,
                        boost: 1,
                    });
                }
            });
        })
        .map((searchResult) => searchResult.ref)
        .slice(0, 5);
}
